import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { IonCheckbox, IonIcon, IonItem } from '@ionic/angular/standalone';
import { CollectionTemplateAgreement } from "../../models/CollectionTemplateAgreement";
import { FormsModule } from '@angular/forms';
import { SexyModule } from '@qid/sexy';

@Component({
  selector: "app-agreement-view",
  templateUrl: "./agreement-view.component.html",
  styleUrls: ["./agreement-view.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    IonIcon,
    IonItem,
    IonCheckbox
  ]
})

export class AgreementViewComponent implements OnInit {

  @Input() agreement: CollectionTemplateAgreement;
  @Input() viewOnly: boolean = false;
  @Output() agreementChange = new EventEmitter<CollectionTemplateAgreement>();
  public baseIconUrl = 'assets/'

  constructor() {
  }

  ngOnInit() {

  }

}
